import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MiddleOfficeButtonComponent } from '@shared/components/middle-office-button';
import { Schedules } from '@shared/components/schedule/model';
import { GetDayPipe } from '@shared/components/schedule/pipe';

@Component({
  selector: 'app-schedule',
  styleUrl: './schedule.component.scss',
  templateUrl: './schedule.component.html',
  imports: [GetDayPipe, MiddleOfficeButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleComponent {
  readonly schedules = input.required<Schedules[]>();
  readonly specialOpening = input<string[]>();
  readonly isMiddleOffice = input(false);
}
